import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { MasqueradeService } from './viewbid/shared/services/masquerade.service';
import { PendingPickupService } from './viewbid/shared/services/pending-pickup.service';

@Injectable({ providedIn: 'root' })
export class PendingPickupGuard implements CanActivate {
    constructor(
        private readonly pendingPickupService: PendingPickupService,
        private readonly masqueradeService: MasqueradeService,
        private readonly authService: AuthService,
    ) {}

    canActivate(): Observable<boolean> {
        if (this.masqueradeService.isMasquerading()) return of(true);

        return this.authService.isAuthenticated$.pipe(
            take(1),
            map((isAuthenticated: boolean) => {
                if (isAuthenticated) {
                    // Fire-and-forget. Modal opens reactively in AppComponent
                    // when pendingInvoices$ emits non-empty.
                    void this.pendingPickupService.ensureChecked();
                    // Re-emit on every guarded navigation so the modal
                    // re-opens if the user dismissed it (Schedule button)
                    // and navigated back without completing.
                    this.pendingPickupService.republishIfPending();
                }
                return true;
            }),
        );
    }
}
